module.exports = __webpack_public_path__ + "img/faq.059e7948.png";